import { SegmentedControl } from "~/components/segmented-control";
import { COUNTRIES } from "~/lib/countries";
import { MODE_LABEL, transitDays } from "~/lib/modes";
import type { RouteSelection } from "~/lib/use-route-selection";
import { cn } from "~/lib/utils";

export function RoutePicker({ route, labelledBy }: { route: RouteSelection; labelledBy: string }) {
  const onlyOption = route.options.length === 1 ? route.options[0] : null;
  return (
    <div className="space-y-3">
      <div role="radiogroup" aria-labelledby={labelledBy} className="flex flex-wrap gap-2">
        {COUNTRIES.map((country) => {
          const on = country.code === route.origin;
          return (
            <button
              key={country.code}
              type="button"
              role="radio"
              aria-checked={on}
              onClick={() => route.setOrigin(country.code)}
              className={cn(
                "h-11 rounded-full border px-4 text-[15px] font-medium transition-colors",
                on ? "bg-primary text-primary-foreground border-primary" : "bg-surface border-hairline hover:bg-accent",
              )}
            >
              {country.name}
            </button>
          );
        })}
      </div>
      {route.options.length > 1 && (
        <SegmentedControl
          label="How it ships to Kenya"
          value={route.mode}
          onChange={route.setMode}
          segments={route.options.map((o) => ({ value: o.mode, label: MODE_LABEL[o.mode], detail: transitDays(o) }))}
        />
      )}
      {onlyOption && (
        <p className="text-muted-foreground type-footnote">
          Ships by {MODE_LABEL[onlyOption.mode].toLowerCase()}
          {transitDays(onlyOption) ? `, ${transitDays(onlyOption)}` : ""}.
        </p>
      )}
    </div>
  );
}
